/**
 * Validates a value matches a pattern
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {RegExp} context.pattern The pattern to match against.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name pattern
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  if (context.pattern === undefined) {
    throw new Error('no-pattern');
  }

  return Promise.resolve(context.pattern.test(value) ? null : 'pattern-mismatch');
}

module.exports = validate;